import { baseApi } from "./api";

// Admin "permission templates" are the same DB rows as the project preset
// list's system group (projectPermissionPreset where isSystem=true,
// projectId=null). Mutating one must invalidate both caches, so every
// mutation invalidates the shared PermissionPreset LIST tag too.
const SYSTEM_TEMPLATE_INVALIDATES = [
	{ type: "AdminPermissionTemplate", id: "LIST" },
	{ type: "PermissionPreset", id: "LIST" },
];

export const adminPermissionTemplatesApi = baseApi.injectEndpoints({
	endpoints: (build) => ({
		listSystemTemplates: build.query({
			query: () => ({
				url: "admin/permission-templates",
			}),
			providesTags: [{ type: "AdminPermissionTemplate", id: "LIST" }],
		}),
		createSystemTemplate: build.mutation({
			query: (body) => ({
				url: "admin/permission-templates",
				method: "POST",
				body,
			}),
			invalidatesTags: SYSTEM_TEMPLATE_INVALIDATES,
		}),
		updateSystemTemplate: build.mutation({
			query: ({ id, ...body }) => ({
				url: `admin/permission-templates/${id}`,
				method: "PUT",
				body,
			}),
			invalidatesTags: SYSTEM_TEMPLATE_INVALIDATES,
		}),
		deleteSystemTemplate: build.mutation({
			query: (id) => ({
				url: `admin/permission-templates/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: SYSTEM_TEMPLATE_INVALIDATES,
		}),
	}),
});

export const {
	useListSystemTemplatesQuery,
	useCreateSystemTemplateMutation,
	useUpdateSystemTemplateMutation,
	useDeleteSystemTemplateMutation,
} = adminPermissionTemplatesApi;
